import React from "react";
import GenericReviewSection from "../../../common/sections/generic-review-section/GenericReviewSection";



const ComTrustpilotReviewSection = ({ showLogo, title, logo, reviews }) => {

  return (
    <GenericReviewSection logo={logo}  showLogo={showLogo} title={title} reviews={reviews} sectionName="ComTrustpilotReviewSection"/>
  );
};

export const name = "ComTrustpilotReviewSection";

export const init = (componentData, pageContext) => {
  return (
    <ComTrustpilotReviewSection
      showLogo={componentData.showLogo}
      title={componentData.title}
      logo={componentData.logo}
      reviews={pageContext?.trustpilotReviews?.slice(0, componentData.slideCount)}
    />
  );
};

export default ComTrustpilotReviewSection;
